import { useState } from "react";
import PageHeader from "../../components/layout/PageHeader";
import { ProductCard } from "../../components/common/Cards";
import { products, productCategories } from "../../data/products";

export default function ShopGrid() {
  const [cat, setCat] = useState("All");
  const [sort, setSort] = useState("default");

  let list = cat === "All" ? products : products.filter((p) => p.category === cat);
  list = [...list].sort((a, b) => {
    if (sort === "low") return a.price - b.price;
    if (sort === "high") return b.price - a.price;
    return 0;
  });

  return (
    <>
      <PageHeader title="Shop" crumbs={[{ label: "Shop" }]} />
      <section className="section">
        <div className="container">
          <div className="toolbar">
            <div className="flex gap-2 wrap">
              <button className={`btn ${cat === "All" ? "btn-primary" : "btn-outline"}`} onClick={() => setCat("All")}>All</button>
              {productCategories.map((c) => (
                <button key={c} className={`btn ${cat === c ? "btn-primary" : "btn-outline"}`} onClick={() => setCat(c)}>{c}</button>
              ))}
            </div>
            <select value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="default">Default Sorting</option>
              <option value="low">Price: Low to High</option>
              <option value="high">Price: High to Low</option>
            </select>
          </div>
          <div className="grid grid-4">
            {list.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        </div>
      </section>
    </>
  );
}
